import React from 'react';
import PropTypes from 'prop-types';
import './highlight-tags.scss';

const HighLightTags = ({ type = '', source = '' }) => {
  return <div className={`tags type-${type} source-${source}`}>{type}</div>;
};

HighLightTags.propTypes = {
  type: PropTypes.oneOf(['bestseller']),
  source: PropTypes.oneOf([
    'product-card-mweb',
    'product-card-desktop',
    'pdp-desktop',
  ]),
};

export default HighLightTags;
